import { OrganizationTableItem, Task } from '../../types'
import { formatDateString } from '../Tasks/taskUtil'

const fieldLabels = {
  name: 'Task Name',
  masterStatus: 'Master Status',
  status: 'Status',
  startDate: 'Start Date',
  endDate: 'End Date',
  dateDue: 'Due Date',
  type: 'Type',
  isMarketing: 'Marketing Tag',
  isCreative: 'Creative Tag',
  isWebsite: 'Website Tag',
}
const dateFields = ['startDate', 'endDate', 'dateDue']

const formatIfDate = (field: string, value: any) => {
  if (!value) return '—'
  return dateFields.includes(field) ? formatDateString(value) : value
}
// utils/timeline/formatTaskTimelineData.ts
export const formatTaskTimelineData = (
  id: string,
  activeUser: any,
  action: string,
  type: string,
  details: string,
  message: string
) => {
  console.log({
    id,
    timeline_uuid: id,
    dataset: 'tasks',
    user: {
      id: activeUser?.user_uuid || activeUser?.id || activeUser?.user?.id || activeUser?.id || '',
      name:
        activeUser?.name ||
        activeUser?.real_name ||
        activeUser?.user?.real_name ||
        activeUser?.user?.profile?.real_name ||
        '',
      image: activeUser?.image_512 || activeUser?.profile?.image_512 || activeUser?.user?.profile?.image_512 || '',
    },
    action,
    type,
    details,
    message,
  })
  return {
    id,
    timeline_uuid: id,
    dataset: 'tasks',
    user: {
      id: activeUser?.user_uuid || activeUser?.id || activeUser?.user?.id || activeUser?.id || '',
      name:
        activeUser?.name ||
        activeUser?.real_name ||
        activeUser?.user?.real_name ||
        activeUser?.user?.profile?.real_name ||
        '',
      image: activeUser?.image_512 || activeUser?.profile?.image_512 || activeUser?.user?.profile?.image_512 || '',
    },
    action,
    type,
    details,
    message,
  }
}

export const createTimelineEntriesForChanges = (
  updatedRow: OrganizationTableItem | Task,
  oldRow: OrganizationTableItem | Task,
  fields: string[],
  activeUser: any
) => {
  const timelineId = updatedRow.parentSK ?? updatedRow.SK // 👈 Use parentSK if this is a subtask

  return fields
    .filter(field => updatedRow[field] !== oldRow[field])
    .map(field => {
      const newVal = formatIfDate(field, updatedRow[field])
      const oldVal = formatIfDate(field, oldRow[field])
      const label = fieldLabels[field] || field

      const isSubtask = updatedRow?.SK?.startsWith?.('SUBTASK_') || false

      return formatTaskTimelineData(
        timelineId,
        activeUser,
        'Update',
        'task',
        isSubtask ? `Subtask Update - ${label}` : `Updated ${label}`,
        `Changed ${label} from "${oldVal}" to "${newVal}"`
      )
    })
}
